import { render, staticRenderFns } from "./styleConfig.vue?vue&type=template&id=3dddbc32&scoped=true"
import script from "./styleConfig.vue?vue&type=script&lang=js"
export * from "./styleConfig.vue?vue&type=script&lang=js"
import style0 from "./styleConfig.vue?vue&type=style&index=0&id=3dddbc32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dddbc32",
  null
  
)

export default component.exports